import styled from "styled-components";
import { SidebarInset } from "@/components/ui/sidebar";
import { Button } from "@/components/ui/button";
import { AnystaySidebarLogoBtn } from "@/pages/dashboard/SideBar/DashboardSidebarMainStyling";

export const AnyStaySidebarInsetContainer = styled(SidebarInset)`
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 72px;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background: none;
    display: flex;
    z-index: 2;
    user-select: none;

    @media (max-width: 767px) {
        display: none;
    }
`;

export const MainSidebarLogoBtn = styled(AnystaySidebarLogoBtn)<{ showLogo: boolean }>`
    ${({ showLogo }) => !showLogo && 'display: none;'}
`;

export const AnyStaySidebarInsetInnerContainer = styled.div<{ showLogo: boolean }>`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    ${({ showLogo }) => !showLogo && 'margin-top: 0;'}
`;

interface SidebarButtonProps {
    isActive?: boolean;
}

const GREY_FILTER = 'filter: brightness(0) saturate(100%) invert(46%) sepia(0%) saturate(0%) hue-rotate(179deg) brightness(92%) contrast(85%);'

export const SidebarButton = styled(Button)<SidebarButtonProps>`
    width: 48px;
    height: 48px;
    
    margin-bottom: 0;
    box-shadow: ${(props) => (props.isActive ? "initial" : "inherit")};
    border: 1px solid transparent;
    background: transparent;
    border-radius: 12px;
    
    &:hover {
        background: rgba(0, 0, 0, 0.04);
        backdrop-filter: blur(16px);
    }

    &:active {
        transform: scale(0.95);
    }

    &[data-active="true"] {
        box-shadow: initial;
        border: 1px solid transparent;
        background: transparent;

        &:hover {
            background: rgba(0, 0, 0, 0.04);
            backdrop-filter: blur(16px);
        }
    }
`;

export const MainSidebarButtonIcon = styled.img<SidebarButtonProps>`
    ${({ isActive }) => isActive ? 'filter: brightness(0%) saturate(100%);' : GREY_FILTER}
    
    [data-active="true"] & {
        filter: brightness(0%) saturate(100%);
    }
`;

export const SidebarButtonLink = styled.div<SidebarButtonProps>`
    width: 48px;
    height: 48px;
    margin-bottom: 4px;
    box-shadow: ${(props) => (props.isActive ? "initial" : "inherit")};
    border: 1px solid transparent;
    background: transparent;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    
    &:hover {
        background: rgba(0, 0, 0, 0.04);
        backdrop-filter: blur(16px);
    }

    &:active {
        transform: scale(0.95);
    }
`;
